import { render, staticRenderFns } from "./vSearch.vue?vue&type=template&id=544e3ddf&scoped=true"
import script from "./vSearch.vue?vue&type=script&lang=js"
export * from "./vSearch.vue?vue&type=script&lang=js"
import style0 from "./vSearch.vue?vue&type=style&index=0&id=544e3ddf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e3ddf",
  null
  
)

export default component.exports